import { useState, useEffect } from "react";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

function NewMarkerModal({ show, onHide, onCommentUpdate, initialComment }: {
    show: boolean,
    onHide: () => void,
    onCommentUpdate: (comment: string) => void,
    initialComment?: string,
}) {
    const [comment, setComment] = useState("");
    const isEdit = initialComment !== undefined;

    useEffect(() => {
        if (show) {
            setComment(initialComment ?? "");
        }
    }, [show, initialComment]);

    const updateComment = () => {
        setComment("");
        onCommentUpdate(comment);
    }

    return (
        <div
            className="modal show"
            style={{ display: 'block', position: 'initial' }}
        >
            <Modal show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? "Beschreibung bearbeiten" : "Beschreibung des Platzes"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {!isEdit && <p>Zum Beispiel Ort, Vorteile, Nachteile, Link zu Google Maps, ...</p>}
                    <Form.Control
                        as="textarea" rows={5}
                        type="text"
                        placeholder="Beschreibung"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Abbrechen</Button>
                    <Button variant="primary" onClick={updateComment}>Speichern</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default NewMarkerModal;
